import { useEffect, useState } from 'react';
import { Alert, Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import { deleteDonorReasonList } from '../delete-donor-reasons';

interface IProps {
    show: boolean,
    alias: string,
    onCancel: () => void,
    onDelete: (reasonCode: number, reason: string, initials: string) => void
}

const DeleteDonorModal = (props: IProps) => {
    const [reasonCode, setReasonCode] = useState(0);
    const [reason, setReason] = useState('');
    const [initials, setInitials] = useState('');
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        if (!props.show) {
            setReasonCode(0);
            setReason('');
            setInitials('');
            setDirty(false);
        }
    }, [props.show])

    const validate = (dirty: boolean) => {
        let reasonCodeValid = dirty ? reasonCode != 0 : true;
        let reasonValid = dirty ? ((reasonCode == 1 && reason != '') || reasonCode != 1) : true;
        let initialsValid = dirty ? initials != '' : true;

        let isValid = reasonCodeValid && reasonValid && initialsValid;

        return { reasonCodeValid, reasonValid, initialsValid, isValid };
    }

    const handleSubmit = () => {
        setDirty(true);

        let isValid = validate(true).isValid;

        if (isValid) {
            props.onDelete(reasonCode, reason, initials);
        }
    };

    const { reasonCodeValid, reasonValid, initialsValid, isValid } = validate(dirty)

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title> Please Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isValid && (
                    <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                        The fields in <strong>red</strong> are required...
                    </Alert>
                )}

                <blockquote>Alias: {props.alias}</blockquote>

                <FormGroup validationState={reasonCodeValid == false ? 'error' : null}>
                    <ControlLabel>Reason For Deletion</ControlLabel>
                    <FormControl
                        componentClass='select'
                        value={reasonCode}
                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => setReasonCode(parseInt(e.currentTarget.value))}
                    >
                        <option value={0}> Please Select</option>
                        {deleteDonorReasonList.map(item =>
                            <option key={'ddId-' + item.id} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                </FormGroup>

                {reasonCode == 1 &&
                    <FormGroup validationState={reasonValid == false ? 'error' : null}>
                        <ControlLabel>'Other' Details</ControlLabel>
                        <FormControl
                            value={reason}
                            onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => setReason(e.currentTarget.value)}
                        />
                    </FormGroup>
                }

                <FormGroup validationState={initialsValid == false ? 'error' : null}>
                    <ControlLabel>Initials</ControlLabel>
                    <FormControl
                        value={initials}
                        maxLength={3}
                        onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => setInitials(e.currentTarget.value)}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={handleSubmit}>Delete Donor</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteDonorModal;